'use strict';
import * as $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024 from "./com.raquo.ew.-Js-Array$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_tags_CustomHtmlTag$() {
  $n_Lcom_raquo_laminar_tags_CustomHtmlTag$ = this;
  $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().R2(new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([0]))));
}
export { $c_Lcom_raquo_laminar_tags_CustomHtmlTag$ as $c_Lcom_raquo_laminar_tags_CustomHtmlTag$ };
$p = $c_Lcom_raquo_laminar_tags_CustomHtmlTag$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_tags_CustomHtmlTag$;
/** @constructor */
function $h_Lcom_raquo_laminar_tags_CustomHtmlTag$() {
}
export { $h_Lcom_raquo_laminar_tags_CustomHtmlTag$ as $h_Lcom_raquo_laminar_tags_CustomHtmlTag$ };
$h_Lcom_raquo_laminar_tags_CustomHtmlTag$.prototype = $p;
$p.eO = (function() {
  return new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => (void 0)));
});
var $d_Lcom_raquo_laminar_tags_CustomHtmlTag$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_tags_CustomHtmlTag$, "com.raquo.laminar.tags.CustomHtmlTag$", ({
  iR: 1
}));
export { $d_Lcom_raquo_laminar_tags_CustomHtmlTag$ as $d_Lcom_raquo_laminar_tags_CustomHtmlTag$ };
var $n_Lcom_raquo_laminar_tags_CustomHtmlTag$;
function $m_Lcom_raquo_laminar_tags_CustomHtmlTag$() {
  if ((!$n_Lcom_raquo_laminar_tags_CustomHtmlTag$)) {
    $n_Lcom_raquo_laminar_tags_CustomHtmlTag$ = new $c_Lcom_raquo_laminar_tags_CustomHtmlTag$();
  }
  return $n_Lcom_raquo_laminar_tags_CustomHtmlTag$;
}
export { $m_Lcom_raquo_laminar_tags_CustomHtmlTag$ as $m_Lcom_raquo_laminar_tags_CustomHtmlTag$ };
